export type DateTimeValue = string | Date;

const PERSIAN_DATE_FORMATTER = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
  dateStyle: "short",
});
const PERSIAN_TIME_FORMATTER = new Intl.DateTimeFormat("fa-IR", {
  timeStyle: "short",
});

export function formatPersianDateTime(value: DateTimeValue): string {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return "-";

  return `${PERSIAN_DATE_FORMATTER.format(date)}, ${PERSIAN_TIME_FORMATTER.format(date)}`;
}
